<script>
    import {list_notebooks} from '../controller.js'
    import Entry from '../components/Entry.svelte'

    let entry_map = {}
    let entry_by_id = {}
    let entry_selector_name_by_id = {}
    let entry_to_notebook = {}
    for (const notebook of list_notebooks()) {
        for (const entry of Object.values(notebook.entries)) {
            entry_map[`${entry.name} (${notebook.name})`] = entry;
            entry_to_notebook[entry.id] = notebook;
            entry_by_id[entry.id] = entry;
            entry_selector_name_by_id[entry.id] = `${entry.name} (${notebook.name})`
        }
    }

    let selected_entry_name = null;
    $: selected_entry = entry_map[selected_entry_name];

    function on_link_click(clicked_entry_id) {
        selected_entry = entry_by_id[clicked_entry_id]
        selected_entry_name = entry_selector_name_by_id[clicked_entry_id]
    }

</script>

<div id="container">
    <input type="text" placeholder="Search..." list="entries" bind:value={selected_entry_name}>
    <datalist id="entries">
        {#each Object.keys(entry_map) as item}
            <option value={item}>
        {/each}
    </datalist>
    <div id="results">
    {#if selected_entry != null}
        <Entry
            notebook={entry_to_notebook[selected_entry.id]}
            entry={selected_entry}
            callback={on_link_click}
        />
    {:else}
        Select an entry to view
    {/if}
    </div>
</div>


<style>
input {
    width: 100%;
}
</style>
